import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.user.facebook.profile,
    props.user.facebook.button,
    (profile, button) => {
        return {
            profile,
            button
        }
    }
)